<template>
  <form id="FormularioCrud" class="columns is-multiline" @submit.prevent="sendForm">
    <b-field class="column is-6" label="Socio *" label-position="horizontal">
      <b-input v-model="form.socio" type="text" required></b-input>
    </b-field>

    <b-field class="column is-6" label="Nombre *" label-position="horizontal">
      <b-input v-model="form.nombre" type="text" required></b-input>
    </b-field>

    <b-field class="column is-6" label="Apellido" label-position="horizontal">
      <b-input v-model="form.apellido" type="text"></b-input>
    </b-field>

    <b-field class="column is-6" label="Teléfono" label-position="horizontal">
      <b-input v-model="form.telefono" type="text"></b-input>
    </b-field>

    <b-field
      class="column is-12"
      label="Contraseña"
      message="Debe tener al menos 8 caracteres, incluir 1 mayúscula, 1 minúscula y 1 número."
      label-position="horizontal"
    >
      <b-input v-model="form.password" type="password" password-reveal></b-input>
    </b-field>

    <b-field class="column is-6" label="Email *" label-position="horizontal">
      <b-input v-model="form.email" type="email" required></b-input>
    </b-field>

    <b-field class="column is-6" label="RFC *" label-position="horizontal">
      <b-input v-model="form.rfc" type="text" required></b-input>
    </b-field>

    <b-field class="column is-6" label="Nombre comercial" label-position="horizontal">
      <b-input v-model="form.nombre_comercial" type="text" disabled></b-input>
    </b-field>

    <b-field class="column is-6" label="Empresa" label-position="horizontal">
      <b-input v-model="form.empresa" type="text" disabled></b-input>
    </b-field>

    <b-field class="column is-6" label="Paquete" label-position="horizontal">
      <b-input v-model="form.paquete" type="text" disabled></b-input>
    </b-field>

    <b-field class="column is-6" label="Vigencia" label-position="horizontal">
      <b-input v-model="form.vigencia" type="date" disabled></b-input>
    </b-field>

    <b-field class="column is-6" label="Jefe de sección" label-position="horizontal">
      <b-switch v-model="form.jefe_seccion" disabled></b-switch>
    </b-field>

    <b-field class="column is-6" label="Jefe de círculo" label-position="horizontal">
      <b-switch v-model="form.jefe_circulo" disabled></b-switch>
    </b-field>

    <b-button class="is-success" type="submit" native-type="submit" label="Guardar" expanded></b-button>
  </form>
</template>

<script>
import { mapActions } from 'vuex';
import Swal from 'sweetalert2';

export default {
  props: {
    datavalues: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      form: {},
      initialFormState: {
        id: null,
        nombre: '',
        apellido: '',
        empresa: '',
        nombre_comercial: '',
        telefono: '',
        email: '',
        password: '',
        socio: '',
        jefe_seccion: false,
        jefe_circulo: false,
        rfc: '',
        paquete: '',
        vigencia: '',
      },
    };
  },
  watch: {
    datavalues: {
      immediate: true,
      handler(newData) {
        this.loadFormData(newData);
      },
    },
  },
  methods: {
    ...mapActions({
      submitForm: 'associates/submitForm', // Asegúrate de tener esta acción en Vuex
    }),
    async loadFormData() {
      if (this.datavalues && Object.keys(this.datavalues).length) {
        Object.keys(this.initialFormState).forEach((key) => {
          this.form[key] = this.datavalues[key] ?? this.initialFormState[key];
        });

        this.form.password = this.initialFormState.password;
        this.form.jefe_seccion = this.datavalues.jefe_seccion == '1' || this.initialFormState.jefe_seccion;
        this.form.jefe_circulo = this.datavalues.jefe_circulo == '1' || this.initialFormState.jefe_circulo;
      } else {
        this.form = { ...this.initialFormState };
      }
    },
    async sendForm() {
      const payload = {
        ...this.form,
        jefe_seccion: this.form.jefe_seccion ? 1 : 0,
        jefe_circulo: this.form.jefe_circulo ? 1 : 0,
      };

      if (this.form.password !== '' && !this.isPasswordValid(this.form.password)) {
        Swal.fire({
          icon: 'error',
          title: 'La contraseña debe contener al menos una letra mayúscula, una letra minúscula y un número.',
          confirmButtonColor: '#268af7',
        });
        this.isLoading = false;
        return;
      }

      const response = await this.submitForm(payload);

      Swal.fire({
        icon: response.status ? 'info' : 'error',
        title: response.message,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: true,
      });

      if (response.status) {
        this.$store.commit('associates/SET_DATA', { key: 'reloadList', data: true });
        this.closeForm();
      }
    },
    closeForm() {
      this.$emit('close-form');
    },
    isPasswordValid(password) {
      // Expresión regular para al menos una mayúscula, una minúscula y un número
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/;
      return regex.test(password);
    },
  },
};
</script>

<style scoped>
.form-horizontal {
  max-width: 600px;
  margin: auto;
}
</style>
